module.exports = __webpack_public_path__ + "static/other/colony.59d35a39.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/colony.json
// module id = 2276
// module chunks = 0